import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

import CategoriesList from "./Categories/CategoriesList.jsx";
import Malfunctions from "./Malfunctions/index.jsx";

const messages = {
  malfunctions: {
    id: "modules.Malfunctions.components.Dashboard.malfunctions",
    description: "Index label.",
    defaultMessage: "Malfunctions",
  },
  pendingMalfunctions: {
    id: "modules.Malfunctions.components.Dashboard.pendingMalfunctions",
    description: "Pending Index label.",
    defaultMessage: "Pending malfunctions",
  },
  categories: {
    id: "modules.Malfunctions.components.Dashboard.categories",
    description: "Categories label.",
    defaultMessage: "Categories",
  },
};

const Dashboard = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey = location.hash || "#malfunctions";

  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        {intl.formatMessage(messages.malfunctions)}
      </Card.Header>
      <Card.Body>
        <Tabs
          activeKey={activeKey}
          onSelect={(key) => navigate(key)}
          id="malfunctions-dashboard-tabs"
          className="custom-tabs"
        >
          <Tab
            eventKey="#malfunctions"
            title={intl.formatMessage(messages.pendingMalfunctions)}
          >
            <Malfunctions />
          </Tab>
          <Tab
            eventKey="#categories"
            title={intl.formatMessage(messages.categories)}
          >
            <CategoriesList />
          </Tab>
        </Tabs>
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
